module.exports = __webpack_public_path__ + "static/media/41-10.0b394646.mp3";